import { SITEMAP_REPORT } from '@components/Router/constants'
import { IconWorld } from '@lib/icons'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useSelector } from 'react-redux'
import { generatePath } from 'react-router-dom'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import css from './Access.module.scss'
import { Clipboard } from './components/Clipboard'
import { Members } from './components/Members'
import { ShareOptions } from './components/ShareOptions'

const Access: React.FC = () => {
  const id = useSelector(migrationProjectSelector.getProjectId)
  const isReport = useSelector(migrationProjectSelector.getProjectIsReport)

  // A report opens on its own screen, not on the canvas route.
  const path = isReport ? generatePath(SITEMAP_REPORT, { uuid: id }) : `/${id}`

  const origin = `${window.location.origin}${path}`

  // A report link is read-only for anyone from the moment the report exists:
  // there is nothing to choose, so the chooser is not shown at all.
  return (
    <>
      <div className={css.gap_12}>
        <div className={css.share}>
          <Clipboard
            defaultValue={origin}
            onCopy={
              isReport
                ? () => sendGtmEvent(GtmTriggerName.REPORT_SHARE_LINK_COPY)
                : undefined
            }
          />
          {!isReport && <ShareOptions />}
          {isReport && (
            <div className={css.report_access}>
              <IconWorld size={14} />
              Anyone with the link can view
            </div>
          )}
        </div>
      </div>

      <Members />
    </>
  )
}

export default Access
